export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10938.f4f65a19.jpg";